<template>
  <page-header></page-header>

  <div class="innerPageBanner partnerBanner">
    <div class="container-sm">
      <div class="row">
        <div class="col-md-12">
          <div class="innerBannerText">
            <h1>Privacy Policy for Canada Parcel Network App and Postmedia Parcel Services App</h1>
            <p style="text-align: justify">
              This Privacy Policy describes how Canada Parcel Network collects,
              uses, and shares information when you use our mobile application
              (the "Canada Parcel Network").
            </p>
            <p>Information We Collect</p>
            <p>
              When you use the App, we may collect the following types of
              information:
            </p>
            <ul>
              <li>Camera: We may access your device's camera to allow you to take photos or videos within the App.</li>
              <li>Location: We may collect your device's location information to provide you with location-based services, such as finding nearby stores or events.</li>
              <li>Internet: We may collect information about your device's internet connection, such as IP address, browser type, and operating system.</li>
              <li>Device ID: We may collect your device's unique identifier, such as the IMEI or Android ID, to help us identify and troubleshoot issues with the App.</li>
            </ul>
            <p>How We Use Your Information</p>
            <p>We may use the information we collect for the following purposes:</p>
            <ul>
              <li>To provide and improve the App's features and functionality.</li>
              <li>To personalize your experience with the App.</li>
              <li>To communicate with you about the App and related products or services.</li>
              <li>To comply with legal obligations or protect our rights and interests.</li>
            </ul>
            <p>Information Sharing</p>
            <p>We may share your information with third-party service providers who help us operate the App, such as hosting providers or analytics providers. We may also share your information with law enforcement or other third parties if required by law or to protect our rights and interests.</p>
            <p>Your Choices</p>
            <p>You can choose to disable location services or camera access for the App in your device's settings. You can also choose to opt-out of certain types of data collection by adjusting your device's settings or by contacting us at [contact email].</p>
            <p>Updates to this Policy</p>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
            <p>Contact Us</p>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at apps@brunswicknews.com.</p>
            <p>By using the App, you agree to the terms of this Privacy Policy. If you do not agree with the terms of this Privacy Policy, please do not use the App.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Track Parcel page Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4 fs-3">
            Proof of Delivery, review the delivery image
          </div>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "./PageFooter.vue";
import PageHeader from "./PageHeader.vue";

export default {
  beforeMount() {
    scroll(0, 0);
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>
